"use client";

import { IconLogout } from "@tabler/icons-react";
import { useTranslations } from "next-intl";
import { useRouter } from "next/navigation";
import { useState } from "react";
import { Button } from "@/components/ui/Button";
import { signOut, useSession } from "@/lib/auth-client";

/**
 * Sign-out control, shown only when a session exists — so it never appears on a
 * public map. After signing out we `router.refresh()`: the current page is
 * server-gated, so it must be re-rendered without the cookie (which sends a
 * protected map back to the login page).
 */
export function LogoutButton() {
  const t = useTranslations("login");
  const router = useRouter();
  const { data: session } = useSession();
  const [pending, setPending] = useState(false);

  if (!session) return null;

  async function onClick() {
    setPending(true);
    await signOut();
    router.refresh();
  }

  return (
    <Button variant="ghost" size="xs" onClick={onClick} disabled={pending}>
      <IconLogout size={16} className="text-neutral-500" aria-hidden />
      <span className="text-sm font-normal">{t("signOut")}</span>
    </Button>
  );
}
